import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router'

import { Layout } from './components/ui/Layout'
import { EmailUpdate } from './pages/EmailUpdate'
import { Home } from './pages/Home'
import { WalletConnect } from './pages/WalletConnect'

const rootRoute = createRootRoute({
  component: Layout
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: Home
})

const wcRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/wc',
  component: WalletConnect,
  validateSearch: (search: Record<string, unknown>) => {
    // For connection request
    if (typeof search.uri === 'string') {
      return {
        uri: search.uri,
        provider: typeof search.provider === 'string' ? search.provider : undefined
      }
    }
    // For signing request
    if (typeof search.requestId === 'string' && typeof search.sessionTopic === 'string') {
      return {
        requestId: search.requestId,
        sessionTopic: search.sessionTopic
      }
    }
    // Return empty object if no valid parameters
    return {}
  }
})

const emailUpdateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/emailUpdate/$sessionTopic',
  component: EmailUpdate,
  validateSearch: (search: Record<string, unknown>) => {
    // Validate sessionTopic from params, not search
    return {}
  }
})

export const routeTree = rootRoute.addChildren([indexRoute, wcRoute, emailUpdateRoute])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
